export default __webpack_public_path__ + "static/media/SearchIcon.6f78a946.png";